import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import BacklogIcon from "@atlaskit/icon/core/backlog";
import ChartBubbleIcon from "@atlaskit/icon/core/chart-bubble";
import BrowserExtensionIcon from "@atlaskit/icon-lab/core/browser-extension";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components";
import { ContentTypeImage } from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/content-type-image.tsx";
import type {
    TabProps,
    TabType
} from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/tab-type.tsx";

import { tabbedHeroSectionCaptureMessages } from "../reusable-xflow-hero-component/tabbed-hero-section.messages.tsx";

type CaptureContentTypeProps = TabProps;

export const CaptureContentType: TabType = ({}: CaptureContentTypeProps) => {
    const intl = useIntl();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { user } = useUserContext();

    return (
        <ContentTypeImage
            imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/4rto2jp1t0bj3a27w6785p1a4ynon8bp.webp"
            imageAlt="This is an image of Jira Product Discovery's backlog, that shows a list of ideas, and how insights are generated from them."
            title={intl.formatMessage(
                tabbedHeroSectionCaptureMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionCaptureMessages.contentDescription
            )}
            hideSeparator={true}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionCaptureMessages.contentFeaturePoint1
                    ),
                    icon: <BacklogIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionCaptureMessages.contentFeaturePoint2
                    ),
                    icon: <ChartBubbleIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionCaptureMessages.contentFeaturePoint3
                    ),
                    icon: <BrowserExtensionIcon label="" />
                }
            ]}
            cta={
                <Link
                    href={"/software/jira/product-discovery"}
                    text={intl.formatMessage(
                        tabbedHeroSectionCaptureMessages.contentCta
                    )}
                    type={"primary"}
                    dataEventProps={{
                        "data-product-key": "jiraProductDiscovery",
                        "data-event-component": "linkButton",
                        "data-event-container": "tabsMenu",
                        "data-event": "clicked",
                        "data-label": "try-it-out",
                        "data-label-english": "Explore Jira Product Discovery",
                        "data-track-event":
                            "jpd-pt.content-types.capture-ideas.cta"
                    }}
                    onClick={() => {
                        createAnalyticsEvent({
                            eventName: "jpd-crossflow-tab-cta-clicked",
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "linkButton",
                            actionSubjectId: "jpdCrossFlowHeroSection",
                            attributes: {
                                reactComponent: "CaptureContentType",
                                tab: "capture-ideas",
                                userTeamType: user.extended_profile?.team_type
                            }
                        }).fire();
                    }}
                />
            }
            reverseLayout
        />
    );
};
